import React, { useContext } from "react";
import { ThemeContext } from "styled-components";
import Amplify from "aws-amplify";
import {
  Authenticator,
  ConfirmSignUp,
  ForgotPassword,
  SignUp,
  SignIn
} from "aws-amplify-react";
import { withRouter } from "react-router-dom";
import { useAuthContext } from "./AuthContext";
import awsExports from "./aws-exports";
import authenticatorConfig, { signUpConfig } from "./authenticatorConfig";
import CustomForgotPassword from "./AuthComponents/CustomForgotPassword";
import CustomSignIn from "./AuthComponents/CustomSignIn";
import CustomSignUp from "./AuthComponents/CustomSignUp";
import CustomConfirmSignUp from "./AuthComponents/CustomConfirmSignUp";
import { AuthNavHome } from "./AuthNavHome";
import { isMobileDevice } from "../../utils/mobile";

Amplify.configure(awsExports);

const AuthPages = ({ location, history }) => {
  const { setIsAuthenticated } = useAuthContext();
  const theme = useContext(ThemeContext);

  const handleStateChange = state => {
    if (state === "signedIn") {
      setIsAuthenticated(true);
      // redirect
      const redirect = new URLSearchParams(location.search.slice(1)).get(
        "redirect"
      );
      history.push(redirect || "/");
    } else if (state === "signIn") {
      setIsAuthenticated(false);
    }
  };

  return (
    <>
      <AuthNavHome theme={theme} />
      {isMobileDevice() && <div style={{ marginBottom: 54 }} />}
      <Authenticator
        {...authenticatorConfig(theme)}
        onStateChange={handleStateChange}
        hide={[SignIn, SignUp, ConfirmSignUp, ForgotPassword]}
      >
        <CustomSignIn override={"SignIn"} />
        <CustomSignUp override={"SignUp"} signUpConfig={signUpConfig} />
        <CustomConfirmSignUp override="ConfirmSignUp" />
        <CustomForgotPassword override={"ForgotPassword"} />
      </Authenticator>
    </>
  );
};

export default withRouter(AuthPages);
